
<script context="module">

import { 
  VmMenu 
} from '@vime/core';

import { define } from '../lib';
  

define('vm-menu', VmMenu);
  
</script>

<script>
import { createEventDispatcher, onMount } from 'svelte';
import { setProp } from '../lib';

let __ref;
let __mounted = false;

const dispatch = createEventDispatcher();

let className;

export let style;
export { className as class };

export let active = false;
export let identifier;
export let controller = undefined;
export let slideInDirection = undefined;
export const focusMenu = (...args) => __ref.focusMenu(...args);
export const blurMenu = (...args) => __ref.blurMenu(...args);
export const getActiveMenuItem = (...args) => __ref.getActiveMenuItem(...args);
export const setActiveMenuItem = (...args) => __ref.setActiveMenuItem(...args);
export const calculateHeight = (...args) => __ref.calculateHeight(...args);
export const ref = () => __ref;
export const getWebComponent = () => __ref;

onMount(() => { 
  

  __mounted = true; 
});

$: if (__mounted) setProp(__ref, 'controller', controller);

const onEvent = (e) => {
  e.stopPropagation();
  dispatch(e.type, e.detail);
};
</script>

<vm-menu 
  class={className}
  style={style}
  active={active}
  identifier={identifier}
  slide-in-direction={slideInDirection}
  on:vmOpen={onEvent}
  on:vmClose={onEvent}
  on:vmFocus={onEvent}
  on:vmBlur={onEvent}
  on:vmActiveSubmenuChange={onEvent}
  on:vmActiveMenuItemChange={onEvent}
  on:vmMenuHeightChange={onEvent}
  bind:this={__ref}
>
  <slot></slot>
</vm-menu>
  